import React from 'react';
import { useFullscreenCard, FullscreenButton, FullscreenBackdrop } from '../ReportsNative/Fullscreen';

export function Card({ title, right, children, frostedBackground, style, className, expandable = false }) {
  const { isFullscreen, toggle, exit } = useFullscreenCard();
  const fs = expandable && isFullscreen;
  return (
    <>
    {expandable && <FullscreenBackdrop active={fs} onClose={exit} />}
    <section
      className={`rn-dash-card relative overflow-hidden transition-all duration-150${fs ? ' rn-card-fs' : ''} ${className || ''}`}
      style={{
        padding: 'var(--sp-6)',
        borderRadius: 'var(--radius-xl)',
        background: 'var(--lodge-white)',
        border: '1px solid var(--lodge-onyx-100)',
        boxShadow: 'var(--shadow-sm)',
        ...style,
      }}
    >
      {(title || right) && (
        <header
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 20,
            paddingBottom: 16,
            borderBottom: '1px solid var(--lodge-onyx-100)',
          }}
        >
          <h3
            style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 17,
              fontWeight: 700,
              color: 'var(--lodge-onyx-800)',
              letterSpacing: '-0.2px',
              margin: 0,
            }}
          >
            {title}
          </h3>
          {(right || expandable) && (
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              {right}
              {expandable && <FullscreenButton isFullscreen={fs} onToggle={toggle} />}
            </div>
          )}
        </header>
      )}
      <div
        style={{
          color: 'var(--lodge-onyx-700)',
          flex: '1 1 auto',
          minHeight: 0,
        }}
      >
        {children}
      </div>
    </section>
    </>
  );
}